<template>
  <div class="news-dynamic">
    <div class="news-dynamic-title">企业动态</div>
    <div class="news-dynamic-list">
      <div class="news-dynamic-top" @click="handleDetails(headlinesInfo.id)">
        <div class="news-item-box">
          <imgContainer :src="headlinesInfo.cover" />
        </div>
        <div class="dynamic-top-info">
          <div class="info-name">
            <div class="info-name-list">
              <div v-show="headlinesInfo.headlines == 1" class="dynamic-top-tou">头条</div>
              <div class="dynamic-top-title" :title="headlinesInfo.title">{{ handleChara(headlinesInfo.title, 25) }}</div>
            </div>
            <div class="dynamic-top-time">{{ formatDayYYYYMMDD(headlinesInfo.createTime) }}</div>
          </div>
          <div class="info-instructions" :title="headlinesInfo.introduction">
            {{ handleChara(headlinesInfo.introduction, 249) }}
          </div>
        </div>
      </div>
      <div class="news-dynamic-bottom" v-if="newsList.length>1">
        <ul class="dynamic-other">
          <li v-for="item in newsList" :key="item.id" @click="handleDetails(item.id)">
            <span class="other-name">{{item.title}}</span><span>{{ formatDayYYYYMMDD(item.createTime) }}</span>
          </li>
        </ul>
        <div class="other-line"></div>
        <ul class="dynamic-other">
          <li v-for="item in dynamicList" :key="item.id" @click="handleDetails(item.id)">
            <span class="other-name">{{item.title}}</span><span>{{ formatDayYYYYMMDD(item.createTime) }}</span>
          </li>
        </ul>
      </div>
      <div class="news-dynamic-btn" @click="handleList">更多资讯>></div>
    </div>
  </div>
</template>

<script setup>
import {getEnterpriseList} from "@/api/apiNews";
import {computed, ref} from "vue";
import {formatDayYYYYMMDD} from "@/utils/day";
import {handleChara} from "@/utils/title";
import router from "@/router";
import imgContainer from '@/components/imgContainer/index.vue'

const enterpriseList = ref([])
const headlinesInfo = computed(function () {
  if (enterpriseList.value.length > 0) {
    const list = enterpriseList.value.filter(item => item.headlines == 1)
    return list && list.length > 0 ? list [0] : enterpriseList.value [0]
  }
  return {}
})
const newsList = computed(function () {
  if (enterpriseList.value.length > 8) {
    return enterpriseList.value.slice(1,5);
  }
  return []
})
const dynamicList = computed(function () {
  if (enterpriseList.value.length > 8) {
    return enterpriseList.value.slice(5,9);
  }
  return []
})
const queryEnterpriseList = async () => {
  const {code, data} = await getEnterpriseList({pageNum: 1, pageSize: 9})
  if (code === 200) {
    enterpriseList.value = data.records
  }
}
const handleDetails = (id) => {
  router.push('/newsDetails?id='+id)
}
const handleList=()=>{
  router.push('/newsList')
}
queryEnterpriseList()
</script>

<style lang="scss" scoped>
.news-dynamic {
  width: 1200px;
  margin: 70px auto 0 auto;
}

.news-dynamic-title {
  font-weight: bold;
  font-size: 28px;
  color: #242424;
  position: relative;
  text-align: center;
}

.news-dynamic-title::after {
  content: "";
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
  width: 52px;
  height: 4px;
  background: #0048A9;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.news-dynamic-list {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.news-dynamic-top {
  display: flex;
  cursor: pointer;
}
.news-item-box{
  width: 409px;
  height: 211px;
}
.dynamic-top-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dynamic-top-info {
  margin-left: 30px;
  flex: 1;
}

.info-name {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.info-name-list {
  display: flex;
  align-items: center;
}

.dynamic-top-tou {
  width: 42px;
  height: 27px;
  text-align: center;
  line-height: 27px;
  background: #FF8F21;
  font-weight: bold;
  font-size: 16px;
  color: #FFFFFF;
  margin-right: 10px;
}

.dynamic-top-title {
  font-weight: bold;
  font-size: 24px;
  color: #0048A9;
}

.dynamic-top-time {
  font-size: 18px;
  color: #797979;
}

.info-instructions {
  font-size: 18px;
  color: #797979;
  margin-top: 20px;
}

.news-dynamic-bottom {
  width: 1200px;
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dynamic-other {
  font-size: 18px;
  color: #797979;
  width: 570px;
  li {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    text-align: left;
    cursor: pointer;
    &:first-child {
      margin-top: 0;
    }
    &::before {
      content: "•"; /* Unicode 圆点符号 */
      color: #797979; /* 自定义颜色 */
      font-size: 1.2em; /* 调整大小 */
      display: inline-block;
      margin-left: -1px; /* 左对齐文本 */
      margin-top: -4px;
    }
  }
}

.other-line {
  width: 1px;
  height: 156px;
  background: #D8D8D8;
}

.other-name {
  width: 433px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.news-dynamic-btn {
  width: 146px;
  height: 44px;
  text-align: center;
  line-height: 44px;
  border-radius: 6px;
  border: 1px solid #0048A9;
  font-size: 20px;
  color: #0048A9;
  margin-top: 40px;
  cursor: pointer;
}
</style>
